import Flex from '@Components/Bases/Flex';
import { Box, Typography } from '@mui/material';
import DisclosureGuidelineGhGasMgmtReport from '@Router/EsgGreenhouse/Components/DisclosureGuidelineGhGasMgmtReport';
import GreenhouseGasEmissionOrganization from './GreenhouseGasEmissionOrganization';
import GreenhouseGasEmissionVerify from './GreenhouseGasEmissionVerify/GreenhouseGasEmissionVerify';
import GreenhouseGasMgmtReportCompletedCheckbox from './GreenhouseGasMgmtReportCompletedCheckbox';
import GreenhouseGasMgmtReportIntroduction, {
  GH_GAS_MGMT_REPORT_INTRODUCTION_ID,
} from './GreenhouseGasMgmtReportIntroduction';
import GreenhouseGasMgmtReportRemark, {
  GH_GAS_MGMT_REPORT_REMARK_ID,
} from './GreenhouseGasMgmtReportRemark';
import PerformanceGhgasMgmt from './PerformanceGhgasMgmt/PerformanceGhgasMgmt';
import { PF_GH_GAS_MGMT_REPORT_REMARK_ID } from './PerformanceGhgasMgmt/PerformanceGhgasMgmtRemark';

const GreenhouseGasMgmtReport = () => {
  return (
    <Box bgcolor={'white'}>
      <Box p={2}>
        <Flex justifyContent={'space-between'} alignItems={'center'}>
          <Flex gap={1} alignItems={'center'}>
            <Typography fontWeight={'bold'}>
              การรายงานผลการดำเนินงานและผลลัพธ์การจัดการก๊าซเรือนกระจก
            </Typography>
            <Flex gap={0.5} alignItems={'center'}>
              <GreenhouseGasMgmtReportIntroduction />
              <GreenhouseGasMgmtReportRemark />
            </Flex>
          </Flex>
          <DisclosureGuidelineGhGasMgmtReport />
        </Flex>
        <Box id={GH_GAS_MGMT_REPORT_INTRODUCTION_ID} />
        <Box id={GH_GAS_MGMT_REPORT_REMARK_ID} />
        <PerformanceGhgasMgmt />
        <Box id={PF_GH_GAS_MGMT_REPORT_REMARK_ID} />
        <GreenhouseGasEmissionOrganization />
        <GreenhouseGasEmissionVerify />
      </Box>
      <GreenhouseGasMgmtReportCompletedCheckbox />
    </Box>
  );
};
export default GreenhouseGasMgmtReport;
